import { Component, Input } from '@angular/core';
import { animate, style, transition, trigger } from "@angular/animations";
import { CommonModule } from '@angular/common';

@Component({
    selector: 'minster-show-hide',
    standalone: true,
    imports: [CommonModule],
    templateUrl: 'minster-show-hide.component.html',
    animations:[
        trigger('myInsertRemoveTrigger', [
            transition(':enter', [style({height: 0}), animate('200ms', style({height: '*'}))]),
            transition(':leave', [animate('200ms', style({height: 0}))]),
          ]),
      ],
})
export class MinsterShowHideComponent {
    @Input() isVisible : boolean | undefined | null;
}
